import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

// Read the per-request nonce injected by the Lambda@Edge CspNonceFunction.
// Passed to Emotion so its <style> tags carry the nonce attribute.
// Note: style-src uses 'unsafe-inline' (not nonce-only) because JSS/MUI v4,
// swagger-editor, PDS LitElement components, and other runtime style injectors
// cannot attach a nonce to their dynamically created styles.
// See infra/lambdas/csp_nonce/index.js.
const cspNonce =
  document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')?.content ??
  '';

// JSS (used by MUI v4 components) checks window.__webpack_nonce__ each time it creates
// a <style> element. Setting this before React renders ensures every JSS stylesheet
// gets the nonce attribute and is allowed by the 'style-src nonce-...' CSP directive.
// Without this, JSS <style> elements are blocked → sheet is null →
// "Cannot read properties of null (reading 'cssRules')" → app crash.
if (cspNonce) {
  (window as any).__webpack_nonce__ = cspNonce;
}

const emotionCache = createCache({ key: 'css', nonce: cspNonce });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <CacheProvider value={emotionCache}>
    <App />
  </CacheProvider>,
);
